// extracted by mini-css-extract-plugin
export default {"emptyState":"EmptyState-module__emptyState--T_45S","emptyStateHeading":"EmptyState-module__emptyStateHeading--alMtZ"};